import { useTranslation } from "react-i18next";

import { LANGUAGES, setLanguage, type LanguageCode } from "../i18n";

/**
 * Two-letter language buttons in the header.
 *
 * A pair of buttons rather than a select: with two languages a dropdown is a click
 * more for the same choice, and the codes are short enough to read at this size. The
 * choice is remembered per device, and is not part of the account — the same driver
 * may well want English on one machine and French on another.
 */
export function LanguagePicker() {
  const { i18n } = useTranslation();
  const active = i18n.resolvedLanguage ?? i18n.language;

  return (
    <div className="flex rounded-md border border-zinc-800 p-0.5">
      {LANGUAGES.map((language) => (
        <button
          key={language.code}
          type="button"
          onClick={() => setLanguage(language.code as LanguageCode)}
          aria-label={language.label}
          aria-current={active === language.code}
          title={language.label}
          className={[
            "rounded px-1.5 py-0.5 text-[10px] font-medium uppercase tracking-wider transition-colors",
            active === language.code
              ? "bg-zinc-800 text-zinc-200"
              : "text-zinc-500 hover:text-zinc-300",
          ].join(" ")}
        >
          {language.code}
        </button>
      ))}
    </div>
  );
}
